/**
 * ПОЛНЫЙ ПУТЬ: D:\QR\QR-WEB\dashboard\src\components\Business\BusinessBulkCreate.js
 * ВЕРСИЯ: 1.0
 * ДАТА: 20.11.2025
 * СТАТУС: ✅ PRODUCTION READY
 */

import React, { useState } from 'react';

const API_URL = 'https://qr-money.onrender.com/api';

const BusinessBulkCreate = () => {
  const [quantity, setQuantity] = useState(1);
  const [amount, setAmount] = useState(10);
  const [ttlHours, setTtlHours] = useState(24);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [createdQRs, setCreatedQRs] = useState([]);

  const handleBulkCreate = async (e) => {
    e.preventDefault();

    if (!quantity || quantity < 1 || quantity > 1000) {
      setError('Количество должно быть от 1 до 1000');
      return;
    }

    if (!amount || amount <= 0) {
      setError('Сумма должна быть больше 0');
      return;
    }

    try {
      setLoading(true);
      setError('');
      setSuccess('');
      setCreatedQRs([]);

      const token = localStorage.getItem('authToken');
      const qrs = [];

      for (let i = 0; i < parseInt(quantity); i++) {
        const response = await fetch(`${API_URL}/business/qr-codes`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify({
            amount: parseFloat(amount),
            ttlHours: parseInt(ttlHours),
            description: `Bulk QR ${i + 1}/${quantity}`
          })
        });

        if (!response.ok) {
          throw new Error(`Ошибка при создании QR ${i + 1}`);
        }

        const result = await response.json();
        if (result.success) {
          qrs.push(result.data);
        }

        // Progress
        const progress = Math.round((i + 1) / quantity * 100);
        console.log(`📊 Прогресс: ${progress}%`);
      }

      setCreatedQRs(qrs);
      setSuccess(`✅ Создано ${qrs.length} QR кодов!`);
    } catch (err) {
      console.error('❌ Error:', err.message);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const downloadCSV = () => {
    const csv = [
      ['QR ID', 'Сумма', 'Статус', 'Истекает'],
      ...createdQRs.map(qr => [
        qr.qrId,
        qr.amount,
        qr.status,
        qr.expiresAt
      ])
    ].map(row => row.join(',')).join('\n');

    const blob = new Blob([csv], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `qr-codes-${Date.now()}.csv`;
    a.click();
  };

  return (
    <div style={{ padding: '20px', maxWidth: '600px', margin: '0 auto' }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '10px' }}>📦 Массовое создание QR</h1>
      <p style={{ color: '#666', marginBottom: '20px' }}>Создайте несколько QR кодов одновременно</p>

      {error && (
        <div style={{
          background: '#ffebee',
          color: '#c62828',
          padding: '12px',
          borderRadius: '8px',
          marginBottom: '20px',
          borderLeft: '4px solid #c62828'
        }}>
          ❌ {error}
        </div>
      )}

      {success && (
        <div style={{
          background: '#e8f5e9',
          color: '#2e7d32',
          padding: '12px',
          borderRadius: '8px',
          marginBottom: '20px',
          borderLeft: '4px solid #4caf50'
        }}>
          {success}
        </div>
      )}

      <form onSubmit={handleBulkCreate} style={{
        background: 'white',
        padding: '20px',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        marginBottom: '20px'
      }}>
        {/* КОЛИЧЕСТВО */}
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600', color: '#2c3e50' }}>
            📊 Количество QR кодов
          </label>
          <input
            type="number"
            min="1"
            max="1000"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            disabled={loading}
            style={{
              width: '100%',
              padding: '10px',
              border: '2px solid #e1e8ed',
              borderRadius: '6px',
              fontSize: '1rem'
            }}
          />
          <small style={{ color: '#999' }}>От 1 до 1000</small>
        </div>

        {/* СУММА */}
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600', color: '#2c3e50' }}>
            💰 Сумма каждого QR (USDT)
          </label>
          <input
            type="number"
            min="0.01"
            step="0.01"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            disabled={loading}
            style={{
              width: '100%',
              padding: '10px',
              border: '2px solid #e1e8ed',
              borderRadius: '6px',
              fontSize: '1rem'
            }}
          />
          <small style={{ color: '#999' }}>
            Итого потребуется: {(quantity * amount).toFixed(2)} USDT
          </small>
        </div>

        {/* ВРЕМЯ ЖИЗНИ */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{ display: 'block', marginBottom: '6px', fontWeight: '600', color: '#2c3e50' }}>
            ⏰ Время жизни QR (часы)
          </label>
          <select
            value={ttlHours}
            onChange={(e) => setTtlHours(e.target.value)}
            disabled={loading}
            style={{
              width: '100%',
              padding: '10px',
              border: '2px solid #e1e8ed',
              borderRadius: '6px',
              fontSize: '1rem',
              cursor: 'pointer'
            }}
          >
            <option value="1">1 час</option>
            <option value="6">6 часов</option>
            <option value="24">24 часа (сутки)</option>
            <option value="72">72 часа (3 дня)</option>
            <option value="168">168 часов (неделя)</option>
          </select>
        </div>

        {/* КНОПКА */}
        <button
          type="submit"
          disabled={loading}
          style={{
            width: '100%',
            padding: '12px',
            background: loading ? '#ccc' : 'linear-gradient(135deg, #2ecc71 0%, #27ae60 100%)',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            fontSize: '1rem',
            fontWeight: '600',
            cursor: loading ? 'not-allowed' : 'pointer',
            transition: 'all 0.3s ease'
          }}
        >
          {loading ? '⏳ Создаю QR коды...' : '🎁 Создать QR коды'}
        </button>
      </form>

      {/* РЕЗУЛЬТАТЫ */}
      {createdQRs.length > 0 && (
        <div style={{
          background: 'white',
          padding: '20px',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0,0,0,0.08)'
        }}>
          <h3 style={{ marginBottom: '15px', color: '#2c3e50' }}>
            ✅ Создано {createdQRs.length} QR кодов
          </h3>

          <div style={{
            maxHeight: '300px',
            overflowY: 'auto',
            marginBottom: '15px',
            border: '1px solid #e1e8ed',
            borderRadius: '6px',
            padding: '10px'
          }}>
            {createdQRs.map((qr, idx) => (
              <div key={idx} style={{
                padding: '8px',
                borderBottom: '1px solid #f0f0f0',
                fontSize: '0.85rem',
                fontFamily: 'monospace'
              }}>
                <strong>#{idx + 1}</strong> {qr.qrId?.substring(0, 12)}... - {qr.amount} USDT
              </div>
            ))}
          </div>

          <button
            onClick={downloadCSV}
            style={{
              width: '100%',
              padding: '10px',
              background: '#667eea',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            📥 Скачать CSV
          </button>
        </div>
      )}
    </div>
  );
};

export default BusinessBulkCreate;